import type { IconProps } from '../types/IconProps.ts';
export const DollarSign: IconProps = {
    name: 'DollarSign',
    children: [
        `<path d="M11 3v18M15 6H9a3 3 0 0 0 0 6h4.36" />`,
        `<path d="M9.45 12H13a3 3 0 1 1 0 6H7" />`,
    ]
};